module.exports = __webpack_public_path__ + "img/core8.d5ba8e4a.jpg";